// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.CreateLandlordWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { CreateLandlordWebApiHandler_createLandlord } from '@zg-rentals/ts-rent-payment-client';

import type {
  CreateLandlordWebApiRequestDto,
  CreateLandlordWebApiResponseDto,
} from '@zg-rentals/ts-rent-payment-client';

export interface CreateLandlordWebApiHandler_createLandlord_Args {
  postData: CreateLandlordWebApiRequestDto;
}

export type CreateLandlordWebApiHandler_createLandlord_Options = UseMutationOptions<
  CreateLandlordWebApiResponseDto,
  unknown,
  CreateLandlordWebApiHandler_createLandlord_Args
>;

/**
 * create landlord
 */
export const useCreateLandlordWebApiHandler_createLandlord = ({
  httpClient,
  ...options
}: Omit<CreateLandlordWebApiHandler_createLandlord_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CreateLandlordWebApiHandler_createLandlord_Args) =>
      CreateLandlordWebApiHandler_createLandlord(args.postData, httpClient),
  });
};
